export const colors = {
  black: '#000000',
  white: '#FFFFFF',
  coralRed: '#FF4040',
  aliceBlue: '#F2F6FF',
  textColor: '#4A6973',
  steelTeal: '#50858B',
  mainColor: '#005840',
  pastelMint: '#CFF5CE',
  aliceBlue2: '#E8EFF4',
  ghostWhite: '#F4F7FC',
  mainYellow: '#e9fa07',
  ghostWhite2: '#EDF1FA',
  lavenderMist: '#DBE3F5',
  bodyTextColor: '#333333',
  antiFlashWhite: '#E7EBEB',
  imageBackground: '#FAFAFA',
  transparent: 'transparent',
  secondaryTextColor: '#666666',
  error: '#FF0000',
};

export const theme = { colors };
